import { ClearOutlined } from "@ant-design/icons";
import { useAuthFetch, useHasRole } from "@p0security/frontend-core";
import type { IntegrationStatus } from "@p0security/shared/integrations/shared";
import { Button, Tooltip, message } from "@p0security/ui";
import { useCallback, useState } from "react";

export const ClearCacheButton: React.FC<{
  state: IntegrationStatus;
}> = ({ state }) => {
  const [isClearing, setIsClearing] = useState(false);
  const canEdit = useHasRole("owner");
  // An independent authFetch, rather than the page's shared one: ConfigForm
  // replaces its entire content with a spinner while the page's authFetch is
  // in flight, which would blank the whole form for this action.
  const authFetch = useAuthFetch(undefined, setIsClearing);

  const onClearCache = useCallback(() => {
    void (async () => {
      const response = await authFetch(
        "integrations/splunk-stack/clear-cache",
        {
          method: "POST",
        }
      );
      if (response?.ok) message.success("Cleared cached Splunk Stack data");
    })();
  }, [authFetch]);

  if (!canEdit || state !== "installed") return null;

  return (
    <Tooltip title="Immediately expire data cached from this Lambda handler">
      <Button
        icon={<ClearOutlined />}
        loading={isClearing}
        onClick={onClearCache}
      >
        Clear Cache
      </Button>
    </Tooltip>
  );
};
